<img class="sector-img" [src]="imageSrc" />
<div class="sector-header">
  <nz-skeleton [nzLoading]="loading" [nzActive]="true" [nzParagraph]="false">
    <a
      class="sector-name"
      routerLink="{{ sectorLink }}"
      routerLinkActive="active"
      >{{ sectorName }}</a
    >
  </nz-skeleton>
  <nz-skeleton [nzLoading]="loading" [nzActive]="true" [nzParagraph]="false">
    <a
      class="companies-count"
      routerLink="{{ sectorLink }}"
      routerLinkActive="active"
      >{{ companiesCount }} companies
    </a>
  </nz-skeleton>
</div>
<div>
  <nz-skeleton [nzLoading]="loading" [nzActive]="true" [nzParagraph]="false">
    <table class="industries-table">
      <thead class="table-header">
        <tr>
          <th class="industry-col">Industry</th>
          <th class="comps-col right-aligned-content">Comps Tables</th>
          <th class="coverage-col right-aligned-content">Coverage List</th>
        </tr>
      </thead>
      <tbody class="table-body">
        <tr *ngFor="let data of industryData">
          <td class="name-cell">
            <a
              [title]="data.industry_name"
              [innerHtml]="data.industry_name | textEllipsis: 25"
              routerLink="/comparative-analysis/current"
              [queryParams]="{
                comp_type: 'industry',
                id: data.industry_id,
                sub_id: -1
              }"
            ></a>
          </td>
          <td class="comps-cell right-aligned-content">
            <a
              *ngIf="data.tab_id && hasCompsAccess"
              routerLink="/comparative-analysis/current"
              [queryParams]="{
                comp_type: 'system',
                id: data.tab_id
              }"
              routerLinkActive="active"
              >{{ data.comp_group_count }}</a
            >
            <span *ngIf="data.tab_id && !hasCompsAccess">{{
              data.comp_group_count
            }}</span>
          </td>
          <td class="coverage-cell right-aligned-content">
            <a
              routerLink="{{
                '/reporting/industry/' + sectorName + '/' + data.industry_name
              }}"
              routerLinkActive="active"
              >{{ data.covered_companies_count }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
  </nz-skeleton>
</div>
